import styled from 'styled-components';

export const WrapperInputs = styled.div`
	display: flex;
	gap: 35px;
`;

export const Label = styled.label`
	font-weight: 500;
	font-size: 14px;
	color: #ffffff;
	margin-bottom: 4px;
	margin-top: 10px;
	display: block;
`;

export const ToggleContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 15px;
	margin-bottom: 25px;
`;

export const PriceInfoContainer = styled.div`
	margin-top: 8px;
	margin-bottom: 16px;
	padding: 12px;
	background-color: #f5f5f5;
	border-radius: 4px;
	border-left: 3px solid #4a90e2;
`;

export const PriceInfoLabel = styled.span`
	font-size: 12px;
	color: #666;
	font-weight: 500;
	text-transform: uppercase;
	letter-spacing: 0.5px;
`;

export const PriceInfoValue = styled.span`
	font-size: 16px;
	color: #333;
	font-weight: 600;
	margin-left: 8px;
`;
